/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*-------- EasyTabs Custom Script ------------*/
document.addEventListener("DOMContentLoaded", function(){
  var infoWrapper  = document.querySelector('.Product__InfoWrapper');
  var photoWrapper = document.querySelector('.Product__Wrapper');

  if( infoWrapper && photoWrapper ) {
    var infoBlock = infoWrapper.querySelector(".Product__Info ");
    if( infoBlock ) {
      var minHeight = photoWrapper.offsetHeight;

      // recalculate function
      var _recalc = function(){
        var height = infoBlock.offsetHeight;
        photoWrapper.style.height = ( height > minHeight) ? height + 'px' : minHeight + 'px';
      }

      // on start
      if( window.innerWidth > 1007 ) {
        var times = 0;
        var intervalID = setInterval(function () {
          _recalc();
          if( ++times === 6 ) window.clearInterval(intervalID);
        }, 500);
      }

      // on tab click
      infoWrapper.addEventListener("click", function(e){
        if( window.innerWidth > 1007 ) {
          if( e.target.parentElement.classList.contains("easytabs-tab-item") || e.target.classList.contains("easytabs-tab-item") ) {
            setTimeout( _recalc, 100);

          } else if( e.target.parentElement.classList.contains("easytabs-accordion-item") || e.target.classList.contains("easytabs-accordion-item") ) {
            setTimeout( _recalc, 300);
          }
        }
      });
    }
  }
});
/*-------- EasyTabs Custom Script ------------*/

/*-------- Custom Label Collection and Testimonials w/ Products Sliders on Home Page ------------*/

function flickit() {
  const elem = document.getElementsByClassName("flickit");
  //console.log(elem[0]);
  if(elem[0]){
    var flkty = new Flickity( elem[0], {
      cellAlign: 'left',
      contain: false,
      draggable: true, 
      percentPosition: true, 
      pageDots: false, 
      resize: false, 
      imagesLoaded: true,
      setGallerySize: false,
      adaptiveHeight: false
    });
  }

  if(elem[1]){
    var flkty2 = new Flickity( elem[1], {
      cellAlign: 'left',
      contain: false,
      draggable: true, 
      percentPosition: true, 
      pageDots: false, 
      resize: false, 
      imagesLoaded: true,
      setGallerySize: false,
      adaptiveHeight: false
    });

    flkty2.resize();
  }

  const testies = document.getElementsByClassName("TestimonialwProductsList");
  //console.log(testies[0]);
  if(testies[0]){
    var flktesties = new Flickity( testies[0], {
      pageDots: false,
      wrapAround: true,
      setGallerySize: true
    });
  }

  
};

window.onload = setTimeout(flickit, 1000);

// PDP mobile sticky bar
document.addEventListener("DOMContentLoaded", function () {
  const quantitySection = document.querySelector('.product-info__block-item[data-block-id="quantity_selector"]');
  const buyButtonsSection = document.querySelector('.product-info__block-item[data-block-id="buy_buttons"]');
  const stickyBar = document.querySelector('.sticky__atc-bar');

  if (!quantitySection || !buyButtonsSection || !stickyBar) return;

  // Hide sticky bar when quantity section is in view
  const quantityObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        stickyBar.classList.add('is-hidden');
      }
    });
  }, {
    threshold: 0.1
  });

  // Show sticky bar when buy buttons section is out of view
  const buyButtonsObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyBar.classList.remove('is-hidden');
      }
    });
  }, {
    threshold: 0.1
  });

  quantityObserver.observe(quantitySection);
  buyButtonsObserver.observe(buyButtonsSection);
});

// Trigger ATC button
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sticky__atc-btn').forEach(function(button) {
    button.addEventListener('click', function () {
      const submitButton = document.querySelector('.product-info__block-item[data-block-id="buy_buttons"] .buy-buttons button[type="submit"]');
      if (submitButton) submitButton.click();
    });
  });
});